<template>
  <div class="w-full flex items-center justify-between mb-5">
    <button
      @click="activeMenu = 1"
      :class="{
        'bg-red-500 text-white': activeMenu == 1,
        'bg-gray-200': activeMenu != 1
      }"
      class="text-xs shadow-sm rounded-l p-2"
      style="flex: 1"
    >
      <i class="fa fa-info-circle mr-1"></i>
      Genel
    </button>
    <button
      @click="activeMenu = 2"
      v-if="Number(detail?.state) == 1 || detail?.isPirateDriver"
      :class="
        activeMenu == 2
          ? 'bg-red-500 text-white'
          : Number(detail?.state) == 0
          ? 'bg-gray-50 bg-opacity-60 text-opacity-40 text-black'
          : 'bg-gray-200'
      "
      class="text-xs shadow-sm p-2"
      style="flex: 1"
    >
      <i class="fa fa-tasks mr-1"></i>
      Mevcut
    </button>
    <button
      @click="activeMenu = 3"
      :class="{
        'bg-red-500 text-white': activeMenu == 3,
        'bg-gray-200': activeMenu != 3
      }"
      class="text-xs shadow-sm p-2"
      style="flex: 1"
    >
      <i class="fa fa-clock-o mr-1"></i>
      Geçmiş
    </button>
    <button
      @click="activeMenu = 4"
      :class="{
        'bg-red-500 text-white': activeMenu == 4,
        'bg-gray-200': activeMenu != 4
      }"
      class="text-xs shadow-sm rounded-r p-2"
      style="flex: 1"
    >
      <i class="fa fa-map mr-1"></i>
      Hareket
    </button>
  </div>
</template>

<script>
export default {
  name: "menu-item",
  props: ["detail", "value"],
  model: {
    event: "change",
    prop: "value",
  },
  data() {
    return {
      activeMenu: 1,
    };
  },
  created() {
    this.activeMenu = this.value;
  },
  watch: {
    value(val) {
      this.activeMenu = val;
    },
    activeMenu(val) {
      return this.$emit("change", val);
    },
  },
};
</script>
